import {
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { EnumFilter } from '@lsq-frontend/remote-services/enterprise/common';
import { forLifeOf, LifecycleAware } from '../../../../utilities/rxjs.helpers';
import { Utilities } from '../../../../utilities/utilities.helper';
import { BaseFilterComponent } from '../base-filter.component';

@LifecycleAware()
@Component({
    selector: 'lsq-enum-filter',
    template: `
        <div class="enum-filter filter">
            <lsq-checkbox
                id="enum-all"
                [ngModel]="selectAll"
                (ngModelChange)="toggleAll($event)"
                label="Select All"
            >
            </lsq-checkbox>
            <form [formGroup]="formGroup">
                <ng-scrollbar #scrollBarRef>
                    <div class="enum-container">
                        <lsq-checkbox
                            *ngFor="let enum of enumStrings; let index = index"
                            [id]="column.key + enum"
                            [formControlName]="index"
                            [label]="enum"
                        >
                        </lsq-checkbox>
                    </div>
                </ng-scrollbar>
            </form>
            <lsq-button type="submit" (buttonClick)="emitFilterUpdate()">Ok</lsq-button>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./lsq-enum-filter.component.scss']
})
export class LsqEnumFilterComponent extends BaseFilterComponent implements OnInit, OnDestroy {
    @Input() public filter: EnumFilter<number>;

    public selectAll: boolean;
    public enumStrings: string[];

    constructor(private changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    public ngOnInit(): void {
        this.enumStrings = Utilities.convertEnumToDisplayArray(this.column.enum);
        this.formGroup = this.createFormGroup();
        this.setFilterValues();
        this.formGroup.valueChanges.pipe(forLifeOf(this)).subscribe((formValue) => {
            let selectAllValue = true;
            Object.values(formValue).forEach((value) => {
                if (!value) {
                    selectAllValue = false;
                }
            });
            this.selectAll = selectAllValue;
        });
    }

    public ngOnDestroy(): void {}

    // We treat no filters being set as 'All' Since we would filter everything out
    private areAnyFiltersSet(): boolean {
        return !(
            Object.values(this.formGroup.value).every((element) => !!element) ||
            Object.values(this.formGroup.value).every((element) => !element)
        );
    }

    public toggleAll(value: boolean): void {
        this.enumStrings.forEach((enumValue, enumIndex) => {
            this.formGroup.get(`${enumIndex}`).setValue(value);
        });
    }

    public setFilterValues(): void {
        this.formGroup = this.createFormGroup();

        if (this.filter && this.filter.values && this.filter.values.length) {
            const controls: { [key: string]: AbstractControl } = {};
            this.enumStrings.forEach((enumValue, index) => {
                let setValue = false;
                this.filter.values.forEach((value) => {
                    if (this.column.enum[enumValue] === value) {
                        setValue = true;
                    }
                });
                controls[`${index}`] = new FormControl(setValue);
            });
            this.formGroup = new FormGroup(controls);
        }
        this.selectAll = !this.areAnyFiltersSet();
        Utilities.executeAfterRender(() => this.changeDetectorRef.markForCheck());
    }

    public createFormGroup(): FormGroup {
        const controls: { [key: string]: AbstractControl } = {};

        this.enumStrings.forEach((enumValue, index) => {
            controls[`${index}`] = new FormControl(true);
        });

        return new FormGroup(controls);
    }

    public emitFilterUpdate(): void {
        let values: number[] = null;

        if (this.areAnyFiltersSet()) {
            values = [];
            this.enumStrings.forEach((enumValue, enumIndex) => {
                if (this.formGroup.value[enumIndex]) {
                    values.push(this.column.enum[enumValue]);
                }
            });
        }
        const filterData = { [this.column.filterField]: new EnumFilter<number>({ values }) };
        this.updated.emit(filterData);
    }
}
